import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { Modal } from '@madeeasy/universal-login';
import { useSearchParams } from 'next/navigation';
import subjective from '../../../public/assets/dailysubj-icon.png';
import calender from '../../../public/assets/calendar-20.png';
import { ShortDateformat } from '../../utils/helpers';
import { useUser } from '../../contexts/ssr-user-context';
import { useMiscellaneousData } from '../../contexts/ssr-miscellaneous-context';
import { trackEvent } from '../../utils/analytics';
// import { useMiscellaneousData } from '../../contexts/ssr-miscellaneous-context';

// check html tag
function isHTML(str) {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}
function QuestionCard({
  questionList, pageType, index,
}) {
  // const pathname = usePathname();
  const searchParams = useSearchParams();
  const { user } = useUser();
  const status = questionList?.attemptInfo?.status;
  const isLoggedIn = Boolean(user?.id);
  // const { miscellaneousData } = useMiscellaneousData();
  const [showLogin, setShowLogin] = useState(false);

  const toggleModal = () => {
    // console.log('toggleModal');
    setShowLogin(false);
  };
    // clever tab event
  const trackSubjectiveStart = (questionId) => {
    trackEvent('Free_Subjective_Question_Started', {
      questionId,
      questionLanguage: questionList?.question?.contentInLanguages?.[0]?.language,
      screenName: 'Daily Subjective Test',
    });
  };
  const router = useRouter();
  const { miscellaneousData } = useMiscellaneousData();
  const handleRedirect = (id) => {
    const targetPath = `/prep/daily-subjective-test/${id}`;
    const fullRedirectUrl = `https://${miscellaneousData?.hostname}${targetPath}`;

    if (isLoggedIn) {
      trackSubjectiveStart(id);
      router.push(`/daily-subjective-test/${id}`);
    } else {
    // Add redirectTo param to URL
      trackSubjectiveStart(id);
      const params = new URLSearchParams(searchParams.toString());
      params.set('redirectTo', fullRedirectUrl);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      // `prep${pathname}?${params.toString()}`;
      window.history.replaceState(null, '', newUrl);
      setShowLogin(true);
    }
  };
  const sanitizedHTML = questionList?.question?.contentInLanguages?.[0]?.content
    .replace(/<pre/g, '<div')
    .replace(/<\/pre>/g, '</div>')?.replace(/<img[^>]*>\s*<br\s*\/?>/gi, '') // remove <img> + immediate <br>
    ?.replace(/<img[^>]*>/gi, '');
  return (
    <div className={`${pageType === 'Home' ? 'lg:w-[403px] w-full flex-flexAuto' : 'w-full'}  rounded-[10px] bg-white p-3.5  lg:shadow-[0px_2px_15px_0px_#00000012] shadow-[0px_2px_9px_0px_#00000012]`}>
      {/* Top Badges */}
      <div className="flex gap-x-3.5 mb-2.5">
        <Image src={subjective} alt="subjective icon" className="aspect-[1/1] lg:w-14 lg:h-14 w-11 h-11" width="50" height="50" />
        <div className="">
          <div className="flex items-center gap-2 lg:mb-2 mb-1">
            {
              questionList?.question?.subject?.name
            && (
            <span className="px-2 py-[3px] text-xs font-light bg-[#F3F1FF] text-[#7263F8] rounded">
              {questionList?.question?.subject?.name}
            </span>
            )
}
            {questionList?.question?.tags?.[0]?.name
            && (
            <span className="px-2 py-1 text-xs font-light bg-[#ebebeb] text-[#5e5e5e] rounded">
              {questionList?.question?.tags?.[0]?.name}
            </span>
            )}
          </div>
          {/* Title */}
          <h2 className="lg:text-lg text-base font-semibold">{questionList?.question?.topic?.name}</h2>
        </div>

      </div>

      {/* Question */}
      <p className="text-black font-light leading-relaxed mb-4 text-sm flex line-clamp-2">

        {isHTML(sanitizedHTML) ? (
          <>
            <span className="font-semibold text-black pr-1">Q.</span>
            <span className="line-clamp-2" dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
          </>
        ) : (
          <>
            {' '}
            <span className="font-semibold text-black pr-1">{`Q.${index + 1}`}</span>
            {sanitizedHTML}
          </>

        )}
      </p>

      {/* Avatars + Action Button */}
      <div className="flex items-center justify-between mt-4">
        {/* Start Date */}
        <div className="flex items-center justify-center gap-1 text-gray-600 lg:text-sm text-xs">
          <Image src={calender} alt="calender icon" className="aspect-[1/1] lg:w-5 w-4" width="20" height="20" />
          <span className="font-semibold">Date:</span>
          {' '}
          {ShortDateformat(questionList?.date)}
        </div>
        {/* Button */}

        {
            questionList?.attemptInfo?.status === 'Evaluated' && user?.id ? (
              <button onClick={() => handleRedirect(questionList?.id)} type="button" className="lg:px-5 px-4 py-2 bg-tabBlue lg:text-sm text-xs text-white rounded font-light cursor-pointer">
                View Result
              </button>
            ) : (
              <button onClick={() => handleRedirect(questionList?.id)} type="button" className="lg:px-5 px-4 py-2 bg-tabBlue lg:text-sm text-xs text-white rounded font-light cursor-pointer">
                {
                         !isLoggedIn || ['Unattempted', 'Rejected'].includes(status)
                           ? 'Attempt Now'
                           : 'View Summary'
                       }
              </button>

            )
          }

      </div>
      {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
    </div>
  );
}
QuestionCard.propTypes = {
  questionList: PropTypes.any,
  pageType: PropTypes.any,
  index: PropTypes.any,
};
export default QuestionCard;
